ListasActionsService.$inject = ['dialogService', '$q', '$http', '$log', 'DialogsService'];
export default function ListasActionsService(dialogService, $q, $http, $log, DialogsService) {

    var TAG = 'ListasActionsService: ';

    var DIALOG_LISTA_COMPARTIR_TEMPLATE = require('./compartir/dialog-listas-compartir.html');
    var DIALOG_LISTA_COMPARTIR_ID = 'dialog-listas-compartir';

    var DIALOG_LISTA_PUBLICA_TEMPLATE = require('./publica/dialog-listas-publica.html');
    var DIALOG_LISTA_PUBLICA_ID = 'dialog-listas-publica';

    return {
        compartirLista: function (listaId) {
            var options = {title: ucfirst(Lang.get('mensajes.titulo_lista_compartida'))};
            var datos = {listaId: listaId};
            var opcionesExtra = {deshabilitarBotones: true};

            return dialogService.open(DIALOG_LISTA_COMPARTIR_ID, DIALOG_LISTA_COMPARTIR_TEMPLATE, datos, options, opcionesExtra);
        },
        publicaLista: function (listaId, esPublica) {
            var titulo = ucfirst(Lang.get('listas.' + (!esPublica ? 'titulo_publica_lista' : 'titulo_privada_lista')));
            var options = {title: titulo};
            var datos = {listaId: listaId, esPublica: esPublica};
            var opcionesExtra = {deshabilitarBotones: true};

            return dialogService.open(DIALOG_LISTA_PUBLICA_ID, DIALOG_LISTA_PUBLICA_TEMPLATE, datos, options, opcionesExtra);
        }
    }
}